import { useContext, useState } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import { useNavigate } from 'react-router';

import { AuthContext } from '../contexts/AuthContext';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';

import pkg from '../../package.json';

export default function Login() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const { handleLogin } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // const handleRegister = async () => {
  //   // const { data, error } = await supabase.auth.signUp({
  //   //   email: 'aurelius.etherstar@gmail.com',
  //   //   password: 'apple123',
  //   //   options: {

  //   //   }
  //   // });

  //   const userResponse = await supabase.auth.updateUser({
  //     password: 'apple123',
  //   });
  //   console.log(userResponse.data);
  //   console.log(userResponse.error);
  // };

  return (
    <Box
      maxWidth={600}
      width="70%"
      mx="auto"
      mt={5}
      p={3}
      sx={{ textAlign: 'center', boxShadow: 3, borderRadius: 4 }}>
      <Box
        sx={{
          gap: 1.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mb: 5,
        }}>
        <Typography variant="h5">Tranding Admin</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          flexDirection: 'column',
        }}>
        <TextField
          fullWidth
          name="email"
          label="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          sx={{ mb: 3 }}
          slotProps={{
            inputLabel: { shrink: true },
          }}
        />
        <Link variant="body2" color="inherit" sx={{ mb: 1.5 }}>
          Forgot password?
        </Link>
        <TextField
          fullWidth
          name="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? 'text' : 'password'}
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{ m: 0 }}>
                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          sx={{ mb: 3 }}
        />

        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="contained"
          onClick={async () => {
            backdrop.handleBackdropOpen();
            try {
              await handleLogin(email, password);
              navigate('/dashboard', { replace: true });
            } catch (error) {
              snackbar.handleSnackbarOpen('Login failed: ' + error, 'error');
            }
            backdrop.handleBackdropClose();
          }}>
          Log In
        </Button>
      </Box>
      {/* <Divider
        sx={{ my: 3, '&::before, &::after': { borderTopStyle: 'dashed' } }}>
        <Typography
          variant="overline"
          sx={{ color: 'text.secondary', fontWeight: 'fontWeightMedium' }}>
          OR
        </Typography>
      </Divider> */}
      {/* <Button
        onClick={async () => {
          try {
            console.log('before');

            const userDataResponse = await supabase.from('user_data').select();
            console.log('after');
            console.log(userDataResponse.data);
            console.log(userDataResponse.error);

          } catch (error) {
            console.log('error');
            console.log(error);
          }
        }}
        fullWidth
        size="large"
        variant="outlined">
        get user data
      </Button>
      <Button
        onClick={async () => {
          await handleLogout();
        }}
        fullWidth
        size="large"
        variant="outlined">
        Log Out
      </Button>
      <Button
        onClick={async () => {
          const { data, error } = await supabase.auth.resetPasswordForEmail(
            email,
            {
              redirectTo: '/login',
            },
          );
        }}
        fullWidth
        size="large"
        variant="outlined">
        redir
      </Button>
      <Button
        onClick={handleRegister}
        fullWidth
        size="large"
        variant="outlined">
        Register
      </Button> */}
      {/* <Box
        sx={{
          gap: 1,
          display: 'flex',
          justifyContent: 'center',
        }}>
        <IconButton color="inherit">
          <Iconify width={22} icon="socials:google" />
        </IconButton>
        <IconButton color="inherit">
          <Iconify width={22} icon="socials:github" />
        </IconButton>
        <IconButton color="inherit">
          <Iconify width={22} icon="socials:twitter" />
        </IconButton>
      </Box> */}
      <br />
      <footer>Web app v{pkg.version}</footer>
    </Box>
  );
}
